module.exports = __webpack_public_path__ + "img/small_Mahon (26).269b058f.png";